// Copyright (c) 2016 Deere & Company

import React, {Component, PropTypes} from 'react';
import CheckboxWithSearchFilterControlled from '../../../shared/components/facets/checkbox-with-search-filter/controlled';
import FacetFooter from '../../../shared/components/facets/facet-footer';
import {addCollectionLabels} from '../../../shared/services/add-collection-labels';
import {create as createHashMap} from '../../../shared/services/hashmap';
import {isDealerFacetInvalid} from '../../../shared/services/facets';

class DealerRecommendationsFacets extends Component {

    state = {
        dateRequestPickerExpanded: false,
        dealerLocationExpanded: false
    };

    onAccordionToggle = accordionName => {

        this.setState({
            [accordionName]: !this.state[accordionName]
        });

    };

    anyFacetsOpen = () =>
        this.state.dateRequestPickerExpanded || this.state.dealerLocationExpanded;

    render() {

        return (
            <div className='transfer-approval-facets'>
                <CheckboxWithSearchFilterControlled
                    initialState={createHashMap(this.props.dealerAccountsFacet.selectedDealers, 'account')}
                    isExpanded={this.state.dealerLocationExpanded}
                    list={addCollectionLabels(this.props.dealerAccountsFacet.displayedDealers)}
                    minNumberOfItems={4}
                    onCheckboxListChange={this.props.onCheckboxListChange}
                    onClick={this.onAccordionToggle.bind(this, 'dealerLocationExpanded')}
                    onInputChange={this.props.onInputChange}
                    onToggleAll={this.props.onToggleAll}
                    searchInput={this.props.dealerAccountsFacet.searchInput}
                    searchPlaceholder='DEALER_LOCATION_FILTER'
                    title='DEALER_LOCATIONS'
                    valueKey='account'
                />
                {this.anyFacetsOpen() ?
                    <FacetFooter
                        disabled={isDealerFacetInvalid(this.props.dealerAccountsFacet)}
                        onApply={this.props.onApply}
                        onReset={this.props.onReset}
                    /> : null}
            </div>
        );

    }

}

DealerRecommendationsFacets.displayName = 'DealerRecommendationsFacets';
DealerRecommendationsFacets.propTypes = {
    dateFormat: PropTypes.string.isRequired,
    dealerAccountsFacet: PropTypes.object.isRequired,
    onApply: PropTypes.func.isRequired,
    onCheckboxListChange: PropTypes.func.isRequired,
    onInputChange: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
    onToggleAll: PropTypes.func.isRequired
};

export default DealerRecommendationsFacets;



// WEBPACK FOOTER //
// ./src/product/dealer-recommendations/components/dealer-recommendation-facets.js